export const ALL_USER_TYPES = {
  owner: 'Owner',
  admin: 'Administrator',
  manager: 'Account Manager',
  hiring_manager: 'Hiring Manager',
  resource_manager: 'Resource Manager',
  resource: 'Resource',
  agency_recruiter: 'Agency Recruiter',
  recruiter: 'Client Recruiter',
};

export const CLIENT_USER_TYPES = {
  owner: 'Owner',
  admin: 'Administrator',
  hiring_manager: 'Hiring Manager',
  recruiter: 'Client Recruiter',
};

export const SUPPLIER_USER_TYPES = {
  owner: 'Owner',
  admin: 'Administrator',
  resource_manager: 'Resource Manager',
  resource: 'Resource',
  agency_recruiter: 'Agency Recruiter',
};

export const MANAGER_USER_TYPES = {
  admin: 'Administrator',
  manager: 'Account Manager',
};
